<template lang="pug">
.select-container
  .label-select-padrao(v-if="label") {{ label }}
  el-select(
    :value="displayValue"
    @input="onInput"
    placeholder="Selecione"
    class="custom-select"
    popper-class="custom-select-popper"
    :clearable="clearable"
    :filterable="filterable"
    :filter-method="customFilter"
  )
    el-option-group(
      v-for="group in filteredOptions"
      :key="group.id"
      :label="group.name"
      v-show="group.skills.length > 0"
    )
      el-option(
        v-for="item in group.skills"
        :key="item.id"
        :label="item.name"
        :value="item.id"
        :disabled="isDisabled(item.id)"
      )
        div
          .cx-icon
            LucideIcon(v-show="item.id === value" name="Check" :size="16")
          label {{ item.name }}
</template>

<script>
export default {
  name: 'SelectGroup',
  props: {
    options: {
      type: Array,
      required: true,
      // Estrutura esperada: [{ id, name, skills: [{ id, name, classe_id, expertises }] }]
    },
    label: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: ''
    },
    clearable: {
      type: Boolean,
      default: false
    },
    filterable: {
      type: Boolean,
      default: false
    },
    disabledOptions: {
      type: Array,
      default: () => []
      // Array de IDs que devem ser desabilitados
    }
  },
  data() {
    return {
      filterText: ''
    }
  },
  computed: {
    formattedOptions() {
      // Retorna as options já no formato correto da API
      // Apenas garante que existe a estrutura necessária
      if (!this.options || !Array.isArray(this.options)) return []
      return this.options
    },
    filteredOptions() {
      if (!this.filterText) return this.formattedOptions
      
      const searchTerm = this.filterText.toLowerCase()
      
      return this.formattedOptions.map(group => {
        // Verifica se o nome da classe corresponde ao filtro
        const classNameMatch = group.name.toLowerCase().includes(searchTerm)
        
        // Se o nome da classe corresponde, mostra todas as skills
        if (classNameMatch) {
          return group
        }
        
        // Caso contrário, filtra apenas as skills que correspondem
        const filteredSkills = group.skills.filter(skill => 
          skill.name.toLowerCase().includes(searchTerm)
        )
        
        return {
          ...group,
          skills: filteredSkills
        }
      }).filter(group => group.skills.length > 0)
    },
    displayValue() {
      // Se o value começa com "temp-", retorna vazio para o select aparecer sem valor
      if (typeof this.value === 'string' && this.value.startsWith('temp-')) {
        return ''
      }
      return this.value
    }
  },
  methods: {
    onInput(val) {
      this.$emit('input', val)
    },
    isDisabled(itemId) {
      // Verifica se o item está na lista de desabilitados
      // Mas permite selecionar o item atual (caso esteja editando)
      return this.disabledOptions.includes(itemId) && itemId !== this.value
    },
    customFilter(val) {
      this.filterText = val
    }
  }
}
</script>

<style lang="scss">
.select-container {
  width: 100%;

  .label-select-padrao{
    text-align: left;
    color: #9ca3af;
    line-height: 30px;
    font-size: 14px;
  }
}

// Estilo para opções desabilitadas
.custom-select-popper {
  .el-select-dropdown__item.is-disabled {
    opacity: 0.5 !important;
    cursor: not-allowed !important;
    
    &:hover {
      background-color: transparent !important;
    }
  }
}
</style>
